/* Sui Generis Designer Authentication Library V7 */
(() => {
  const initializeGuide = (root) => {
    if (!root || root.dataset.sgAuthV7Initialized === 'true') return;
    root.dataset.sgAuthV7Initialized = 'true';
    const guideDirectory = root.querySelector('[data-sg-guide-directory]');
    const guideOverlay = root.querySelector('[data-sg-directory-overlay]');
    const guideDirectoryClose = root.querySelector('[data-sg-directory-close]');
    const guideDirectoryTriggers = Array.from(root.querySelectorAll('[data-sg-directory-open]'));
    let guideDirectoryLastFocus = null;
    let guideDirectoryCloseTimer = null;

    const setDirectoryTriggerState = (expanded) => {
      guideDirectoryTriggers.forEach((trigger) => trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false'));
    };

    const openGuideDirectory = (trigger) => {
      if (!guideDirectory) return;
      if (guideDirectoryCloseTimer) window.clearTimeout(guideDirectoryCloseTimer);
      guideDirectoryLastFocus = trigger || document.activeElement;
      guideDirectory.hidden = false;
      if (guideOverlay) guideOverlay.hidden = false;
      if (window.matchMedia('(max-width: 900px)').matches) {
        document.documentElement.classList.add('sg-guide-directory-open');
      }
      setDirectoryTriggerState(true);
      window.requestAnimationFrame(() => {
        guideDirectory.classList.add('is-open');
        if (guideOverlay) guideOverlay.classList.add('is-open');
        const searchField = guideDirectory.querySelector('[data-sg-guide-search]');
        if (searchField) searchField.focus({ preventScroll: true });
      });
    };

    const closeGuideDirectory = () => {
      if (!guideDirectory || guideDirectory.hidden) return;
      guideDirectory.classList.remove('is-open');
      if (guideOverlay) guideOverlay.classList.remove('is-open');
      document.documentElement.classList.remove('sg-guide-directory-open');
      setDirectoryTriggerState(false);
      guideDirectoryCloseTimer = window.setTimeout(() => {
        guideDirectory.hidden = true;
        if (guideOverlay) guideOverlay.hidden = true;
      }, 190);
      if (guideDirectoryLastFocus && typeof guideDirectoryLastFocus.focus === 'function') {
        guideDirectoryLastFocus.focus({ preventScroll: true });
      }
    };

    guideDirectoryTriggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        if (guideDirectory && !guideDirectory.hidden) closeGuideDirectory();
        else openGuideDirectory(trigger);
      });
    });
    if (guideOverlay) guideOverlay.addEventListener('click', closeGuideDirectory);
    if (guideDirectoryClose) guideDirectoryClose.addEventListener('click', closeGuideDirectory);

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && guideDirectory && !guideDirectory.hidden) closeGuideDirectory();
    });

    if (guideDirectory) {
      guideDirectory.addEventListener('keydown', (event) => {
        if (event.key !== 'Tab') return;
        const focusable = Array.from(guideDirectory.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'))
          .filter((element) => !element.hidden && element.offsetParent !== null);
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });

      const guideSearch = guideDirectory.querySelector('[data-sg-guide-search]');
      const guideSelect = guideDirectory.querySelector('[data-sg-guide-select]');
      const guideOpen = guideDirectory.querySelector('[data-sg-guide-open]');
      const guideStatus = guideDirectory.querySelector('[data-sg-guide-status]');
      const guideLinksContainer = guideDirectory.querySelector('[data-sg-guide-links]');
      const guideLinks = Array.from(guideDirectory.querySelectorAll('[data-sg-guide-link]'));

      if (guideLinksContainer) {
        guideLinks
          .sort((a, b) => a.dataset.guideName.localeCompare(b.dataset.guideName, undefined, { sensitivity: 'base', numeric: true }))
          .forEach((link) => guideLinksContainer.appendChild(link));
      }

      if (guideSearch && guideSelect && guideOpen && guideStatus) {
        const collator = new Intl.Collator(undefined, { sensitivity: 'base', numeric: true });
        const guides = Array.from(guideSelect.options)
          .filter((option) => option.value)
          .map((option) => ({
            value: option.value,
            name: option.dataset.guideName || option.textContent.replace(/\s+— Current$/, '').trim(),
            current: option.dataset.currentGuide === 'true'
          }))
          .sort((a, b) => collator.compare(a.name, b.name));

        const normalize = (value) => String(value || '').trim().toLocaleLowerCase();

        const renderGuideOptions = () => {
          const query = normalize(guideSearch.value);
          const previousValue = guideSelect.value;
          const matches = guides.filter((guide) => normalize(guide.name).includes(query));

          guideSelect.replaceChildren(new Option('Choose a designer', ''));
          matches.forEach((guide) => {
            const option = new Option(`${guide.name}${guide.current ? ' — Current' : ''}`, guide.value);
            option.dataset.guideName = guide.name;
            if (guide.current) option.dataset.currentGuide = 'true';
            guideSelect.add(option);
          });

          const currentGuide = matches.find((guide) => guide.current);
          if (matches.some((guide) => guide.value === previousValue)) guideSelect.value = previousValue;
          else if (!query && currentGuide) guideSelect.value = currentGuide.value;

          guideOpen.disabled = !guideSelect.value;
          guideStatus.textContent = query
            ? `${matches.length} matching guide${matches.length === 1 ? '' : 's'}`
            : `${guides.length} published guide${guides.length === 1 ? '' : 's'} available`;

          guideLinks.forEach((link) => {
            const name = normalize(link.dataset.guideName);
            link.hidden = Boolean(query) && !name.includes(query);
          });
        };

        const openSelectedGuide = () => {
          if (guideSelect.value) window.location.assign(guideSelect.value);
        };

        renderGuideOptions();
        guideSearch.addEventListener('input', renderGuideOptions);
        guideSelect.addEventListener('change', () => {
          guideOpen.disabled = !guideSelect.value;
        });
        guideOpen.addEventListener('click', openSelectedGuide);
        guideSearch.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter') return;
          const firstGuide = Array.from(guideSelect.options).find((option) => option.value);
          if (!firstGuide) return;
          event.preventDefault();
          guideSelect.value = firstGuide.value;
          openSelectedGuide();
        });
      }
    }

    const sectionNav = root.querySelector('[data-sg-section-nav]');
    const sectionSelect = root.querySelector('[data-sg-section-select]');
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const scrollToGuideSection = (selector) => {
      if (!selector) return;
      const target = root.querySelector(selector);
      if (!target) return;
      target.scrollIntoView({ behavior: prefersReducedMotion ? 'auto' : 'smooth', block: 'start' });
    };

    if (sectionSelect) {
      sectionSelect.addEventListener('change', () => scrollToGuideSection(sectionSelect.value));
    }

    if (sectionNav) {
      const navLinks = Array.from(sectionNav.querySelectorAll('a[href^="#"]'));
      const sectionPairs = navLinks
        .map((link) => ({ link, target: root.querySelector(link.getAttribute('href')) }))
        .filter((pair) => pair.target);

      navLinks.forEach((link) => {
        link.addEventListener('click', (event) => {
          const selector = link.getAttribute('href');
          if (!root.querySelector(selector)) return;
          event.preventDefault();
          scrollToGuideSection(selector);
        });
      });

      const setActiveSection = (activeLink) => {
        navLinks.forEach((link) => link.removeAttribute('aria-current'));
        if (activeLink) {
          activeLink.setAttribute('aria-current', 'location');
          activeLink.scrollIntoView({ block: 'nearest', inline: 'nearest' });
          if (sectionSelect) sectionSelect.value = activeLink.getAttribute('href');
        }
      };

      if ('IntersectionObserver' in window) {
        const sectionObserver = new IntersectionObserver((entries) => {
          const visible = entries
            .filter((entry) => entry.isIntersecting)
            .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
          if (!visible.length) return;
          const activePair = sectionPairs.find((pair) => pair.target === visible[0].target);
          if (activePair) setActiveSection(activePair.link);
        }, { rootMargin: '-24% 0px -66% 0px', threshold: [0, .01, .15] });

        sectionPairs.forEach((pair) => sectionObserver.observe(pair.target));
      }
    }
    // Code interpretation is private and server-side. This file keeps guide navigation only.

    const isWarningHeading = (element) => {
      const text = element.textContent.trim().toLowerCase();
      return text.includes('red flag') || text.includes('warning');
    };

    const isSectionHeading = (element) => {
      return /^H[2-6]$/.test(element.tagName) || element.classList.contains('sg-richtext__subheading');
    };

    root.querySelectorAll('.sg-richtext .metafield-rich_text_field').forEach((field) => {
      if (field.dataset.sgRichTextEnhanced === 'true') return;
      field.dataset.sgRichTextEnhanced = 'true';

      /* Convert Markdown bold-only paragraphs into semantic subheadings. */
      Array.from(field.children).forEach((element) => {
        if (element.tagName !== 'P') return;

        const meaningfulNodes = Array.from(element.childNodes).filter((node) => {
          if (node.nodeType === Node.TEXT_NODE) return node.textContent.trim() !== '';
          return node.nodeType === Node.ELEMENT_NODE;
        });

        if (meaningfulNodes.length !== 1) return;

        const onlyNode = meaningfulNodes[0];
        if (
          onlyNode.nodeType !== Node.ELEMENT_NODE ||
          !['STRONG', 'B'].includes(onlyNode.tagName)
        ) return;

        const heading = document.createElement('h3');
        heading.className = 'sg-richtext__subheading';
        heading.innerHTML = onlyNode.innerHTML;

        if (isWarningHeading(heading)) {
          heading.classList.add('sg-richtext__subheading--warning');
        }

        element.replaceWith(heading);
      });

      /* Native rich-text headings should receive the same warning treatment. */
      Array.from(field.children).forEach((element) => {
        if (!/^H[2-6]$/.test(element.tagName)) return;
        element.classList.add('sg-richtext__subheading');
        if (isWarningHeading(element)) {
          element.classList.add('sg-richtext__subheading--warning');
        }
      });

      /* Wrap each warning heading and its body in a single uninterrupted panel. */
      Array.from(field.querySelectorAll('.sg-richtext__subheading--warning')).forEach((heading) => {
        if (heading.closest('.sg-richtext__warning')) return;

        const warning = document.createElement('aside');
        warning.className = 'sg-richtext__warning';
        warning.setAttribute('aria-label', heading.textContent.trim());

        heading.parentNode.insertBefore(warning, heading);
        warning.appendChild(heading);

        let sibling = warning.nextElementSibling;
        while (sibling && !isSectionHeading(sibling)) {
          const nextSibling = sibling.nextElementSibling;
          warning.appendChild(sibling);
          sibling = nextSibling;
        }
      });
    });
  };

  const initializeLibrary = (root) => {
    if (!root || root.dataset.sgAuthV7Initialized === 'true') return;
    root.dataset.sgAuthV7Initialized = 'true';
    const search = root.querySelector('[data-sg-library-search]');
    const select = root.querySelector('[data-sg-library-select]');
    const openButton = root.querySelector('[data-sg-library-open]');
    const status = root.querySelector('[data-sg-library-status]');
    const grid = root.querySelector('[data-sg-library-grid]');
    const noResults = root.querySelector('[data-sg-library-no-results]');
    const cards = Array.from(root.querySelectorAll('[data-sg-library-card]'));

    const collator = new Intl.Collator(undefined, { sensitivity: 'base', numeric: true });
    const normalize = (value) => String(value || '').trim().toLocaleLowerCase();

    if (grid) {
      cards
        .sort((a, b) => collator.compare(a.dataset.guideName || '', b.dataset.guideName || ''))
        .forEach((card) => grid.appendChild(card));
    }

    if (!search || !select || !openButton || !status) return;

    const guides = Array.from(select.options)
      .filter((option) => option.value)
      .map((option) => ({ value: option.value, name: option.dataset.guideName || option.textContent.trim() }))
      .sort((a, b) => collator.compare(a.name, b.name));

    const render = () => {
      const query = normalize(search.value);
      const previous = select.value;
      const matches = guides.filter((guide) => normalize(guide.name).includes(query));

      select.replaceChildren(new Option('Choose a designer', ''));
      matches.forEach((guide) => {
        const option = new Option(guide.name, guide.value);
        option.dataset.guideName = guide.name;
        select.add(option);
      });
      if (matches.some((guide) => guide.value === previous)) select.value = previous;

      cards.forEach((card) => {
        card.hidden = Boolean(query) && !normalize(card.dataset.guideName).includes(query);
      });

      openButton.disabled = !select.value;
      status.textContent = query
        ? `${matches.length} matching guide${matches.length === 1 ? '' : 's'}`
        : `${guides.length} published guide${guides.length === 1 ? '' : 's'} available`;
      if (noResults) noResults.hidden = matches.length > 0;
    };

    const openSelected = () => {
      if (select.value) window.location.assign(select.value);
    };

    render();
    search.addEventListener('input', render);
    select.addEventListener('change', () => { openButton.disabled = !select.value; });
    openButton.addEventListener('click', openSelected);
    search.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter') return;
      const first = Array.from(select.options).find((option) => option.value);
      if (!first) return;
      event.preventDefault();
      select.value = first.value;
      openSelected();
    });
  };

  const initializeWithin = (scope = document) => {
    if (scope.matches && scope.matches('[data-sg-auth-guide]')) initializeGuide(scope);
    if (scope.matches && scope.matches('[data-sg-auth-library]')) initializeLibrary(scope);
    scope.querySelectorAll?.('[data-sg-auth-guide]').forEach(initializeGuide);
    scope.querySelectorAll?.('[data-sg-auth-library]').forEach(initializeLibrary);
  };

  const boot = () => initializeWithin(document);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => initializeWithin(event.target));
})();
